import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RivalsSpeedsOfReplyComponent } from './rivals-speeds-of-reply.component';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';

const routes = [
  {
      path     : 'rivals-speeds-of-reply',
      component: RivalsSpeedsOfReplyComponent,
      canActivate: [AuthGuard,RoleGuard]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    FuseWidgetModule
  ],
  declarations: [
    RivalsSpeedsOfReplyComponent
  ],
  providers: [
    AuthGuard,
    RoleGuard
  ]
})

export class RivalsSpeedsOfReplyModule { }
